import React, { useCallback, useEffect, useMemo } from 'react';
import _ from 'underscore';
import { Constants, TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxDialog } from '@bingads-webui-cc-react/dialogs';
import { useValidationContext } from '../validation-context';

const { TaxType, CountryCode } = Constants;
const { ConfirmNoGSTINDialog } = TaxDialog;

export const GSTINValidation = () => {
  const {
    i18n,
    getAblInfoData,
    onCancel,
    onContinue,
    setConfirmedNoGSTIN,
  } = useValidationContext();

  const { countryCode, taxData } = getAblInfoData();
  const isGSTINEmpty = useCallback(() => taxData && _.isEmpty(TaxUtils.getTaxValue(taxData.data, TaxType.GSTINNumber)), [taxData]);
  // We should only calculate it once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const showDialog = useMemo(() => countryCode === CountryCode.IN && isGSTINEmpty(), []);

  useEffect(() => {
    if (!showDialog) {
      onContinue();
    }
  // We should only call this once when component did mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDismissClickHandler = useCallback(() => {
    setConfirmedNoGSTIN(true);
    onContinue();
  }, [setConfirmedNoGSTIN, onContinue]);

  return showDialog && (
    <ConfirmNoGSTINDialog
      i18n={i18n}
      onUpdateClick={onCancel}
      onDismissClick={onDismissClickHandler}
      show
    />
  );
};
